import { Directive, Component, ChangeDetectionStrategy, contentChild } from "@angular/core";
import { MatButtonModule } from "@angular/material/button";

@Directive({ selector: "[risrHeaderCardTitle]" })
export class RisrHeaderCardTitle { }

@Directive({ selector: "[risrHeaderCardActions]" })
export class RisrHeaderCardActions { }

@Component({
  selector: "risr-header-card",
  imports: [MatButtonModule],
  changeDetection: ChangeDetectionStrategy.OnPush,
  styles: [
    `
      :host {
        --surface: var(--color-white, #fff);
        --padding: calc(var(--base-padding, 0.64em) * 2);
        --space: var(--space-x, 0.64em);
        --radius: var(--border-radius, 4px);
        --card-shadow: var(--box-shadow, 0 2px 4px rgba(0, 0, 0, 0.1));

        align-items: center;
        background-color: var(--surface);
        border-radius: var(--radius);
        box-shadow: var(--card-shadow);
        display: grid;
        grid-template:
          "title"
          "actions"
          "additional";
        gap: calc(var(--space) * 2);
        justify-content: space-between;
        margin: var(--space) 0;
        padding: var(--padding);
      }

      .header-card__title {
        grid-area: title;
      }

      .header-card__buttons {
        grid-area: actions;
      }

      .header-card__bottom {
        grid-area: additional;
      }

      @media screen and (min-width: 768px) {
        :host {
          grid-template:
            "title      title      actions"
            "additional additional additional";
        }
      }
    `,
  ],
  template: `
    <div class="header-card__title">
      <ng-content select="[risrHeaderCardTitle]"></ng-content>
    </div>
    <div class="header-card__buttons">
      <ng-content select="[risrHeaderCardActions]"></ng-content>
    </div>
    <div class="header-card__bottom">
      <ng-content></ng-content>
    </div>
  `,
})
export class RisrHeaderCard {
  protected customTitle = contentChild(RisrHeaderCardTitle);
  protected customActions = contentChild(RisrHeaderCardActions);
}
